module.exports = __webpack_public_path__ + "img/coins.b21250a6.png";